import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { userService } from "../../services";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useNavigate, useParams } from "react-router-dom";

const PREFIX = "AssociateEmail";

const classes = {
  main: `${PREFIX}-main`,
  center: `${PREFIX}-center`,
  white: `${PREFIX}-white`,
};

const Root = styled("div")(() => ({
  [`&.${classes.main}`]: {
    width: "100%",
    height: "calc(100vh - 150px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(66,66,66,.9490196078431372)",
  },

  [`& .${classes.center}`]: {
    textAlign: "center",
  },

  [`& .${classes.white}`]: {
    color: "white",
  },
}));

const VALIDATION_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  VALIDATED: "VALIDATED",
  ERROR: "ERROR",
};

export default function AssociateEmail() {
  const { t } = useTranslation();
  const history = useNavigate();
  const { key } = useParams();
  const [validation, setValidation] = useState(VALIDATION_STATUS.IN_PROGRESS);
  const user = useSelector((state) => state.user.currentUser);

  function goToHome() {
    history("/");
  }

  useEffect(() => {
    setTimeout(
      () =>
        userService
          .associateEmail(key)
          .then((res) => {
            setValidation(VALIDATION_STATUS.VALIDATED);
          })
          .catch((error) => {
            console.error(error);
            setValidation(VALIDATION_STATUS.ERROR);
          }),
      1000
    );
  }, []);

  return (
    <Root>
      <div className={classes.main}>
        {validation === VALIDATION_STATUS.IN_PROGRESS && (
          <div className={classes.center}>
            <Typography variant="h3">
              {t("account.validation.validating")}
            </Typography>
            <CircularProgress size={50} />
          </div>
        )}
        {validation === VALIDATION_STATUS.VALIDATED && (
          <div className={clsx(classes.center, classes.white)}>
            <h2 className={classes.white}>
              {t("account.validation.validated")}
            </h2>
            <Button variant="contained" color="primary" onClick={goToHome}>
              {t("account.validation.home")}
            </Button>
          </div>
        )}
        {validation === VALIDATION_STATUS.ERROR && (
          <div>
            <h2 className={classes.white}>
              {user && user.account && user.account.validated
                ? t("account.validation.linkError")
                : t("account.validation.error")}
            </h2>
            <Button variant="contained" color="primary" onClick={goToHome}>
              {t("account.validation.home")}
            </Button>
          </div>
        )}
      </div>
    </Root>
  );
}
